import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { DashboardHeaderComponent } from '../../components/header/header.component';

@Component({
  selector: 'app-dashboard-layout',
  imports: [RouterOutlet, DashboardHeaderComponent],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.css',
})
export class DashboardLayoutComponent {

}
